import React from 'react';

import { Select } from '@/components/form/';
import { MarketType as Market, PortfolioType as Portfolio, StockType as Stock } from '@/types';

type Props = {
  portfolios: Portfolio[];
  markets: Market[];
  stocks: Stock[];
  errors?: any;
  onPortfolioSelect: (portfolio?: Portfolio) => void;
  register: (any: any) => any;
};

const TransactionInfo: React.FC<Props> = ({ portfolios, markets, stocks, errors, register }) => (
  <div className="grid grid-cols-2 gap-y-6 gap-x-4 mb-5">
    <div className="sm:col-span-3">
      <Select
        id="portfolioId"
        label="Cartera"
        options={portfolios.map(({ name, id }) => ({ label: name, value: id }))}
        error={errors?.portfolioId}
        register={register({ required: true })}
        aria-required
        required
      />
    </div>

    <div className="sm:col-span-3">
      <Select
        id="marketId"
        label="Mercado"
        defaultValue=""
        options={[
          { value: '', disabled: true, hidden: true },
          ...markets.map((market) => ({ label: market.name, value: market.id })),
        ]}
        error={errors?.marketId}
        register={register({ required: true })}
        aria-required
        required
      />
    </div>

    <div className="sm:col-span-3">
      <Select
        id="stockId"
        label="Ticker"
        defaultValue=""
        options={[
          { value: '', disabled: true, hidden: true },
          ...stocks.map((stock) => ({ label: stock.symbol, value: stock.id })),
        ]}
        error={errors?.stockId}
        register={register({ required: true })}
        aria-required
        required
      />
    </div>
  </div>
);

export default TransactionInfo;
